<template>
  <div class="header" :class="{ 'header--chat': chatWindowStatus == 3 }" ref="header">
    <Greeting
    v-if="chatWindowStatus == 1 || chatWindowStatus == 4" :isUserLogged="isUserLogged" :name="name"
    :message="chatWindowStatusMessage" @closeChat="closeChat" :showExit="chatWindowStatus == 4" />

    <HeaderTop
    v-else-if="chatWindowStatus == 5 || chatWindowStatus == 2 || chatWindowStatus == 6"
    :isUserLogged="isUserLogged" :currentType="currentType" :chatWindowStatusMessage="chatWindowStatusMessage" @closeChat="closeChat"
    />

    <AgentGreeting
    v-else-if="chatWindowStatus == 3"
    @closeChat="closeChat"
    :agent="agent"
    :currentType="currentType"
    />
    <button 
        @click="closeChatWindow" 
        @keyup.enter="closeChatWindow" 
        class="action-icon minimize" 
        :aria-label="$gettext('Minimizar chat')"  
        tabindex="0">
      </button>
  </div>
</template>

<script>


import { mapState, mapGetters, mapMutations } from 'vuex'
import LoadingAnimation from "@/components/LoadingAnimation";
import selectOperator from '@/components/SelectOperator.vue';
import Greeting from '@/components/ChatContent/Header/Greeting.vue';
import HeaderTop from '@/components/ChatContent/Header/HeaderTop.vue';
import AgentGreeting from '@/components/ChatContent/Header/AgentGreeting.vue';

export default {
  props: ['chatWindowStatus', 'currentContent', 'currentType'],
  components: {
    LoadingAnimation,
    selectOperator,
    Greeting,
    HeaderTop,
    AgentGreeting
  },
  methods: {
    ...mapMutations(["setChatOpen", "changeBounce"]),
    closeChat() {
      this.$emit('closeChat');
    },
    closeChatWindow() {
      this.setChatOpen(false);
      this.changeBounce(false);
      this.$store.commit('setChatWindowOpen', !this.$store.state.isChatWindowOpen);
    },
  },

  computed: {
    ...mapState(['user']),
    ...mapGetters(['isUserLogged', 'agent', 'name', 'config']),

    chatWindowStatusMessage() {
      switch (this.chatWindowStatus) {
        case 4:
          return 'No hay agentes disponibles en este momento';
        case 6:
          return 'Tu consulta será atendida en breve';
        default:
          return 'Selecciona el tema de tu consulta y habla con uno de nuestros agentes o déjanos tu consulta.';
      }
    }

  }
}
</script>